module.exports = __webpack_public_path__ + "static/media/Q_4.0a960e5f.png";